import React from 'react'
import { Link } from 'react-router-dom';

export default function SubBlogs(props) {
  return (
    <div className="sub-blog-card">
      <img src={props.image} alt={props.name} className="sub-blog-image" />
      <div className="sub-blog-content">
        <h2 className="sub-blog-title">{props.name}</h2>
        <Link to={`/blog/${props.id}`} className="read-more-btn">Read More</Link>
      </div>
    </div>
  )
}
